
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#fff"}},[_c('path',{attrs:{"d":"M7.22 2.248a3.134 3.134 0 011.124.152A2.52 2.52 0 008.843.888a.264.264 0 00-.264-.264c-.566 0-1.09.186-1.512.5a3.074 3.074 0 01.152 1.124zM2.799 6.664a3.089 3.089 0 01-.177-.193L.3 8.793a.264.264 0 10.373.374l2.323-2.322a3.091 3.091 0 01-.195-.179l-.002-.002zM5.945 2.62c.035.152.057.306.067.46l.662-.66A2.522 2.522 0 005.95.3a.264.264 0 00-.374 0c-.224.224-.401.482-.526.763.025.02.05.041.072.064.41.41.695.927.822 1.492zM9.167 3.516a2.522 2.522 0 00-2.12-.723l-.66.66a3.045 3.045 0 011.953.89.81.81 0 01.064.073c.28-.125.536-.3.76-.523a.264.264 0 00.003-.377zM4.813 4.28l.657-.658a2.535 2.535 0 00-.72-2.121.265.265 0 00-.374 0 2.525 2.525 0 00-.525.764c.025.02.048.04.071.063.528.528.84 1.214.89 1.952zM6.17 3.974c-.109 0-.217.007-.324.02l-.66.66a3.045 3.045 0 011.952.89.805.805 0 01.064.073c.281-.125.54-.302.764-.526a.264.264 0 000-.374 2.522 2.522 0 00-1.795-.743zM4.292 4.497c0-.678-.264-1.316-.744-1.795a.264.264 0 00-.374 0 2.542 2.542 0 00-.177 3.394L4.271 4.82c.014-.106.02-.215.02-.324zM4.97 5.175c-.11 0-.218.007-.325.02L3.37 6.47a2.52 2.52 0 001.599.567c.678 0 1.315-.264 1.795-.744a.264.264 0 000-.374 2.522 2.522 0 00-1.795-.743z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.222 .222)","d":"M0 0h9.022v9.022H0z"}})])])])
          )
        }
      }
    